// extracted by mini-css-extract-plugin
module.exports = {"xs":"0rem","sm":"20rem","md":"37.5rem","lg":"60rem","xl":"71.25rem"};